
export default () => {
    localStorage.removeItem('flyBusToken')
    localStorage.setItem('admin','')
}